$(document).ready(function(){
  // branding
  const customBranding = (() => {
    const brand1 = [
      'background: green',
      'padding: 5px',
      'color: #fff',
      'font-size: 12px',
      'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',
      'font-weight: bold',
      'width: 400px',
    ].join(';');
  
    console.log('%c Pack Kit Developer - Savior WebX (shopify.dev.34@gmail.com)', brand1);
  })();
  // branding

  // Remove localstorage when the page is refreshed
  const navEntries = performance.getEntriesByType('navigation'), 
        navigationType = navEntries.length > 0 ? navEntries[0].type : null, 
        isFirstLoad = navigationType === 'navigate',
        redirectFrom = localStorage.getItem('redirect_from');

  if (!isFirstLoad) {
    localStorage.removeItem('redirect_from');
  }
  // Remove localstorage when the page is refreshed
  
  // Change Edit url to normal URL on page load
  var url = new URL(window.location.href);
  if (url.search.includes('b-id:')) {
    var cleanQuery = url.search.split('&')[0];
    const newUrl = url.origin + url.pathname + (cleanQuery ? cleanQuery : '');
    window.history.replaceState({}, '', newUrl);
  }
  // Change Edit url to normal URL on page load

  window.kitOfferText ="Choisissez une couleur [index]";
  let iconClose = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path class="icon-close-path" d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></svg>';

  function adjustHeight(){
    var header = $('.shopify-section-group-header-group .header__wrapper').length > 0 ? 
                 $('.shopify-section-group-header-group .header__wrapper').outerHeight() : 0, 
        announcement_bar = 0,
        final_top = header + announcement_bar;
    $('.kit-options-drawer').css('top',final_top+'px');
  }  

  $(window).on('scroll resize', function(){
    adjustHeight();
  });
  
  // Close Popup
  $('body').on('click', '.close_kit_popup, .overlay-free-product', function(){
    $('.overlay-free-product, .kit-options-drawer').removeClass('active');
    $('body').removeClass('kit-popup-active unloading');
  });

  // Update "Choisissez une couleur" text dynamically
  window.updateKitText = function() {
      if ($('.kit-options .nail-selector.OfferKit:not(.kit--added):first').length == 0){
        $('.product__bundle-to-cart').hide();
        $('.product__bundle-to-cart').next('.product__add-to-cart').show();
      } else {
        const activeIndex = $('.kit-options .nail-selector.OfferKit:not(.kit--added):first').data('index'),
              activeText = $('.product__bundle-to-cart').data('button-text').replace('[index]', activeIndex);
        $('.product__bundle-to-cart').next('.product__add-to-cart').hide();
        $('.product__bundle-to-cart').attr('data-button-index', activeIndex).show().html(activeText);
      }
  }

  // bundle button click
  $('body').on('click', '.product__bundle-to-cart', function(e){
    e.preventDefault();
    var index = $(this).attr('data-button-index');
    $('.kit-options .nail-selector.OfferKit[data-index="'+ index +'"]').trigger('click');
  });
  
  // click on kit selector
  $('body').on('click', '.kit-options .nail-selector:not(.choosenOptionalKit)', function(e){
    e.preventDefault();
    window.isOffer = $(this).hasClass('OfferKit') ? true : false;
    window.isOptional = $(this).hasClass('OptionalKit') ? true : false;
    window.emptyHTML = $(this).data('product-empty');
    window.cardIndex = parseInt($(this).data('index'));
    
    $('.kit-options .nail-selector').removeClass('active--kit');
    $(this).addClass('active--kit');
    
    // Open popup
    if ($(this).hasClass('OptionalKit')){
      $('.kit-options-drawer .products-col.fp-grid-item').hide();
      $('.kit-options-drawer .products-col:not(.fp-grid-item)').show();
    } else if ($(this).hasClass('OfferKit')) {
      $('.kit-options-drawer .products-col:not(.fp-grid-item)').hide();
      $('.kit-options-drawer .products-col.fp-grid-item').show();
    }
    $('.overlay-free-product, .kit-options-drawer').addClass('active');
    $('body').addClass('kit-popup-active');
    // Open popup

    adjustHeight();
  });

  // click on choosen discount products
  $('body').on('click', '.kit-options .nail-selector.choosenOptionalKit', function(e){
    e.preventDefault();
    var index = parseInt($(this).data('index')), variantId = $(this).data('variant_id');
    
    if (!$(this).hasClass('active--optional')){
      $(this).addClass('active--optional');
    } else {
      $(this).removeClass('active--optional');
    }
  });
  
  // click on color shade
  $('body').on('click', '.collections-kit .products-col', function(e){
    e.preventDefault();
    var product_id = $(this).data('product'), 
        imgSrc = $(this).find('img.kit-product-image').attr('src'), 
        title = $(this).find('p.kit-product-title').html(),
        variantId = $(this).data('variant');

    var selectedKit = $('.kit-options .nail-selector.active--kit');
    selectedKit.attr('data-product', product_id)
               .attr('data-variant_id', variantId)
               .find('.blank_images').html('<img src="'+ imgSrc +'" alt="'+ title +'" />')
    selectedKit.find('.ps-picker-title').html(title);
    selectedKit.append('<button class="ps-sign ps-sign--top-right">'+ iconClose +'</button>');
    
    selectedKit.removeClass('active--kit');
    selectedKit.addClass('kit--added');
    
    const productData = selectedKit[0]?.outerHTML;
    
    if (window.isOptional) {
      let html = '', new_index = window.cardIndex + 1;
          $html = $($.parseHTML(window.emptyHTML));
      
      $.each($html, function(index, element) {
        let $element = $(element);
        if ($element.hasClass('ps-picker-title')) {
          var text = $element.text();
          text = text.replace(window.cardIndex, new_index);
          $element.text(text);
        }
      });

      $.each($html, function(index, element) {
        if (element.outerHTML != undefined) html += element.outerHTML; 
      });

      const $container = selectedKit.closest('.kits-color-options');
      const $buttonPopups = $container.find('.button-popups');

      if ($buttonPopups.find(`.OptionalKit[data-index="${new_index}"]`).length === 0) {
        $buttonPopups.append(`
          <button class="nail-selector grid__item OptionalKit"
                  type="button"
                  data-index="${new_index}"
                  data-product-add=""
                  data-product-empty='${html}'>
            ${html}
          </button>
        `);
      }
    } else {
      if (kitData.product_form_id){
        selectedKit.parents('.product-info').find('.product-info #'+ kitData.product_form_id).find('[data-items_index="item-'+ window.cardIndex +'"]').val(variantId);
      }
    }

    window.updateKitText();
    $('.overlay-free-product, .kit-options-drawer').removeClass('active');
    $('body').removeClass('kit-popup-active unloading');
  });

  // Remove selected grid / shade
  $('body').on('click','button.ps-sign', function(e){
    e.stopPropagation();
    let product = $(this).parents('.nail-selector').data('product'),
        itemIndex = $(this).parents('.nail-selector').data('index'),
        itemkey = '';

    $(this).parents('.nail-selector').attr({'data-product':'','data-variant_id':''}).removeClass('kit--added');
    
    if ($(this).parents('.nail-selector').hasClass('OfferKit')){
      itemkey = `offer_${itemIndex}`;
      $(this).parents('.nail-selector').html($(this).parents('.nail-selector').data('product-empty'));
    } else if ($(this).parents('.nail-selector').hasClass('OptionalKit')){
      // Réinitialise la case optionnelle courante
      var emptyHTML = $(this).parents('.nail-selector').data('product-empty');
      $(this).parents('.nail-selector').html(emptyHTML);
      $(this).parents('.nail-selector').removeAttr('data-product data-variant_id');

      // Supprime toutes les cases optionnelles avec un index supérieur
      var currentIndex = itemIndex;
      $('.kits-color-options .button-popups .OptionalKit').each(function(){
        if (parseInt($(this).data('index')) > currentIndex){
          $(this).remove();
        }
      });
    }
    window.updateKitText();
  });

  $('body').on('click', '.custom-modal-opener', function(e){
    e.stopPropagation();
    var modal_id = $(this).data('modal-id');
    $('#'+modal_id).addClass('open--modal');
    $('body').addClass("overflow-hidden");
  });

  $('body').on('click', '.modal-popup__close', function(e){
    e.preventDefault();
    $(this).parents('.custom-modal-dialog').removeClass('open--modal');
    $('body').removeClass("overflow-hidden");
  });

  window.refreshBundleProducts = function() {
    fetch(kitData.currentProductURL)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html"),
              destinationKit = document.querySelector('[kitdata-drawer]'), 
              sourceKit = html.querySelector('[kitdata-drawer]');
        if (sourceKit && destinationKit) destinationKit.innerHTML = sourceKit.innerHTML;
      });
  }
});